import React from 'react';
import { Row, Empty, Typography } from 'antd';
import classes from './ProjectsListNoProjects.module.scss';

export const ProjectsListNoProjects = () => {
  return (
    <Row align="middle" justify="center" className={classes.noProjectsWrapper}>
      <Empty description={<Typography.Text type="secondary">No created projects</Typography.Text>} />
    </Row>
  );
};
